import { useMutation } from '@tanstack/react-query';

import { deleteFile } from './file.service';
import { UPLOADED_FILES_SERVICE } from './uploaded-files-service';

export const useDeletePendingDocuments = (): ReturnType<
	typeof useMutation<void, unknown, void>
> => {
	const deletePendingDocuments = async (): Promise<void> => {
		const cloudFileIdsToDelete = UPLOADED_FILES_SERVICE.getCloudFileIdsToDelete();

		await Promise.all(
			cloudFileIdsToDelete.map(async (cloudFileId) => {
				await deleteFile(cloudFileId).then(() =>
					UPLOADED_FILES_SERVICE.removeCloudFileIdToDelete(cloudFileId),
				);
			}),
		);
	};

	return useMutation({ mutationFn: deletePendingDocuments });
};
